import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useEnvironment } from '../contexts';
import { LightHorizontalLogo } from '../icons/light-horizontal-logo';
export var Header = function Header() {
    var environment = useEnvironment().environment;
    return /*#__PURE__*/ _jsx("div", {
        className: "p-8 pb-0",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center gap-8",
            children: [
                /*#__PURE__*/ _jsx("a", {
                    href: environment.dashboardUrl,
                    children: /*#__PURE__*/ _jsx(LightHorizontalLogo, {})
                }),
                /*#__PURE__*/ _jsx("hr", {
                    className: "border-b border-[var(--color-border-gray)] w-full"
                })
            ]
        })
    });
};
